import { render, staticRenderFns } from "./CommentItem.vue?vue&type=template&id=17305b42&scoped=true"
import script from "./CommentItem.vue?vue&type=script&lang=js"
export * from "./CommentItem.vue?vue&type=script&lang=js"
import style0 from "./CommentItem.vue?vue&type=style&index=0&id=17305b42&prod&scoped=true&lang=css"
import style1 from "./CommentItem.vue?vue&type=style&index=1&id=17305b42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17305b42",
  null
  
)

export default component.exports